module.exports = __webpack_public_path__ + "assets/img/index-partner3.45a74fbb.jpg";